<template>
    <main class="page-content">
        <slot></slot>
    </main>
</template>

<script>

  export default {
    props: ['page-data'],
    data() {
      return {}
    },
    methods: {
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/body.vue